var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeamerIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-color": "basic",
    width: 24,
    className: "beamer-icon",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H8.73333H9V19L13 15H17C18.1046 15 19 14.1046 19 13V7C19 5.89543 18.1046 5 17 5H7Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H10C10 14.4477 9.55228 14 9 14V15ZM9 19H8C8 19.4045 8.24364 19.7691 8.61732 19.9239C8.99099 20.0787 9.42111 19.9931 9.70711 19.7071L9 19ZM13 15V14C12.7348 14 12.4804 14.1054 12.2929 14.2929L13 15ZM6 7C6 6.44772 6.44772 6 7 6V4C5.34315 4 4 5.34315 4 7H6ZM6 13V7H4V13H6ZM7 14C6.44772 14 6 13.5523 6 13H4C4 14.6569 5.34315 16 7 16V14ZM8.73333 14H7V16H8.73333V14ZM9 14H8.73333V16H9V14ZM8 15V19H10V15H8ZM9.70711 19.7071L13.7071 15.7071L12.2929 14.2929L8.29289 18.2929L9.70711 19.7071ZM17 14H13V16H17V14ZM18 13C18 13.5523 17.5523 14 17 14V16C18.6569 16 20 14.6569 20 13H18ZM18 7V13H20V7H18ZM17 6C17.5523 6 18 6.44772 18 7H20C20 5.34315 18.6569 4 17 4V6ZM7 6H17V4H7V6Z",
    fill: "#5a5859"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 2,
    height: 3,
    fill: "#5a5859"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 2,
    height: 4,
    fill: "#5a5859"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 2,
    height: 2,
    fill: "#5a5859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeamerIcn);
export default __webpack_public_path__ + "static/media/beamer-icn.d38371ffec66db15580263f5b7db81b8.svg";
export { ForwardRef as ReactComponent };